export const getApiUrl = () => {
    if (window.location.host === "localhost:3000") {
        const baseUrl = "https://v2.prevandcare.local:8890/api/internal";
        return baseUrl;
    }
    if (window.location.host === "localhost:3001") {
        const baseUrl = "https://v2.prevandcare.local:8890/api/internal";
        return baseUrl;
    } else {
        const baseUrl = "https://" + window.location.host + "/api/internal";
        return baseUrl;
    }
};
